import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {agent} from "../../../utils/agent";
import * as API from "../../../utils/apiPath";

export const sendReferral = createAsyncThunk(
  "refer/sendReferral",
  async (params, { rejectWithValue }) => {
    try {
      const response = await agent.post(API.SEND_REFER, params);

      if (response.status === 200) {
        return {
          message: response.data.message,
        };
      } else {
        return rejectWithValue(response.data?.message || "Something went wrong");
      }
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const getUserProfile = createAsyncThunk(
  "refer/getUserProfile",
  async (_, { rejectWithValue }) => {
    try {
      const response = await agent.get(API.GETUSERPROFILE);

      return response.data.data; // profile info
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const initialState = {
  loading: false,
  message: "",
  error: null,
};

const referSlice = createSlice({
  name: "refer",
  initialState,
  reducers: {
    clearReferState: (state) => {
      state.loading = false;
      state.message = "";
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(sendReferral.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.message = "";
      })
      .addCase(sendReferral.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload.message;
        state.error = null;
      })
      .addCase(sendReferral.rejected, (state, action) => {
        state.loading = false;
        state.message = "";
        state.error = action.payload || "Failed to send referral";
      });
  },
});

export const { clearReferState } = referSlice.actions;
export default referSlice.reducer;